module.exports = __webpack_public_path__ + "fonts/iconfont.8bd85bc.woff";